var map = {
	"./Bankruptcy-pana.png": 223,
	"./action_img.png": 224,
	"./background.png": 225,
	"./banner_shap.png": 226,
	"./cloud-computing.png": 227,
	"./cloud_01.png": 65,
	"./cloud_02.png": 66,
	"./cloud_03.png": 67,
	"./cloud_04.png": 68,
	"./cloud_05.png": 69,
	"./cloud_06.png": 70,
	"./crm_img1.jpg": 228,
	"./crm_img2.jpg": 229,
	"./crm_img3.jpg": 230,
	"./erp_dashboard.jpg": 231,
	"./erp_icon1.png": 232,
	"./erp_icon2.png": 233,
	"./erp_icon3.png": 234,
	"./erp_icon4.png": 235,
	"./erp_icon5.png": 236,
	"./erp_icon6.png": 237,
	"./growth.png": 238,
	"./img/01.png": 71,
	"./img/02.png": 72,
	"./img/03.png": 73,
	"./img/04.png": 74,
	"./img/05.png": 75,
	"./img/06.png": 76,
	"./img/07.png": 77,
	"./img/08.png": 78,
	"./img/09.png": 79,
	"./img/10.png": 80,
	"./img/11.png": 81,
	"./img/12.png": 82,
	"./img/13.png": 83,
	"./img/14.png": 84,
	"./img/15.png": 85,
	"./img/16.png": 86,
	"./img/17.png": 87,
	"./img/18.png": 88,
	"./img/19.png": 89,
	"./img/20.png": 90,
	"./img/aax.jpeg": 91,
	"./img/alpaca.png": 92,
	"./img/binance.png": 93,
	"./img/coinbase.png": 94,
	"./img/ftx.png": 95,
	"./img/gateio.png": 96,
	"./img/kraken.png": 97,
	"./img/kucoin.jpeg": 98,
	"./img/upstox.png": 99,
	"./img/waves-exchange.png": 100,
	"./img/zerodha.png": 101,
	"./quote.png": 239,
	"./rocket.png": 240,
	"./settings1.png": 241,
	"./shape.png": 242,
	"./stadistics.png": 243,
	"./successful.png": 244,
	"./testimonial_img.jpg": 245,
	"./testimonial_img2.jpg": 246
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 222;